/* Plyr a richiesta: serve solo dove il contenuto CKEditor incorpora un video
   (<oembed> trasformati in myscripts.js). Il CSS viaggia col chunk. */
let plyrPromise = null;

window.loadPlyr = function () {
    if (!plyrPromise) {
        import("../sass/plyr-lazy.scss");
        plyrPromise = import("plyr").then((module) => {
            const Plyr = module.default ?? module;
            window.Plyr = Plyr;
            return Plyr;
        });
    }
    return plyrPromise;
};
